import { poizonChannelID as poizon_channel_id } from '@/utils/urlUtils/getQuery'
type Platform = 'sensors'

export function createTrackConfig() {
  return {
    poizon_trade_rank_list_tab_click(platform: Platform, dataSet: any) {
      if ((window as any).editorFlag === 'edit') return
      if (platform !== 'sensors') return
      return {
        current_page: 810,
        block_type: 1585,
        position: dataSet.index + 1,
        poizon_trade_tab_title: dataSet.title,
        SK: window.dw.getSk(),
      }
    },
    poizon_common_product_list_click(platform: Platform, dataSet: any) {
      let poizon_trade_tab_title = ''
      try {
        poizon_trade_tab_title = document
          .querySelector('.am-tabs-default-bar-tab-active')
          .textContent.trim()
      } catch {
        /** noop */
      }
      if ((window as any).editorFlag === 'edit') return
      if (platform !== 'sensors') return
      return {
        current_page: 810,
        block_type: 112,
        spu_id: dataSet.id,
        spu_price: dataSet[1],
        discount_price: dataSet[2],
        poizon_trade_tab_title,
        tag_title: dataSet.title,
        poizon_channel_id,
        SK: window.dw.getSk(),
      }
    },

    poizon_mail_block_exposure(platform: Platform, dataSet: any) {
      if ((window as any).editorFlag === 'edit') return
      if (platform !== 'sensors') return
      let poizon_trade_tab_title = ''
      try {
        poizon_trade_tab_title = document
          .querySelector('.am-tabs-default-bar-tab-active')
          .textContent.trim()
      } catch {
        /** noop */
      }
      return {
        current_page: 810,
        block_type: 112,
        venue_id: dataSet.pageId,
        venue_title: document.title,
        component_content_info_list: JSON.stringify([
          {
            spu_id: dataSet.id,
            spu_price: dataSet[1],
            discount_price: dataSet[2],
            poizon_trade_tab_title,
            tag_title: dataSet.title,
          },
        ]),
        poizon_channel_id,
        SK: window.dw.getSk(),
      }
    },
  }
}
